import script from "./DesktopMegaMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopMegaMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopMegaMenuItem.vue?vue&type=style&index=0&id=22f967a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f967a6"]])

export default __exports__